import { motion } from "framer-motion"; // Add this import
import React from "react";
import { DEFAULT_PRESETS } from "../../hooks/useHapticsEngine/types";

interface HapticPresetSelectorProps {
  onSelect: (preset: string) => void;
  onClose: () => void;
  currentPreset: string | null;
  onEnable: () => void;
  isEnabled: boolean; // Add this prop
}

export const HapticPresetSelector: React.FC<HapticPresetSelectorProps> = ({
  onSelect,
  onClose,
  currentPreset,
  onEnable,
  isEnabled, // Add this prop
}) => {
  console.log(
    "HapticPresetSelector rendered: " +
      JSON.stringify({
        isEnabled,
        currentPreset,
      })
  );
  const handleSelect = (preset: string) => {
    console.log("Selecting preset in HapticPresetSelector:", preset); // Add logging
    onSelect(preset);
    if (!isEnabled) {
      onEnable(); // Enable haptics when a preset is selected
    }
  };

  return (
    <div className="p-4 bg-zinc-800 rounded-lg relative hps">
      <button
        onClick={onClose}
        className="absolute top-[.9rem] right-2 p-2 text-zinc-400 hover:text-white"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
      <h3 className="text-lg font-semibold mb-4">Select Haptic Preset</h3>

      <div className="relative mb-4 overflow-hidden rounded-md">
        <motion.div
          animate={{
            background: isEnabled
              ? [
                  "linear-gradient(90deg, rgba(234,179,8,1) 0%, rgba(234,179,8,0) 50%, rgba(234,179,8,0) 100%)",
                  "linear-gradient(90deg, rgba(234,179,8,0) 0%, rgba(234,179,8,0) 50%, rgba(234,179,8,1) 100%)",
                ]
              : [
                  "linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%)",
                  "linear-gradient(90deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.7) 100%)",
                ],
            rotate: 160,
            translateX: [0, "100%", "100%", 0],
            boxShadow: isEnabled ? "0 0 10px 5px rgba(234,179,8,0.5)" : "0 0 10px 5px rgba(255,255,255,0.5)",
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
          }}
          className="absolute -inset-12 rounded-md blur-md"
        />
        <div className="absolute inset-[.1105rem] bg-zinc-800 pointer-events-none z-[1] backdrop-blur-sm rounded-[4px]" />

        <div className={`flex items-center justify-between px-4 py-5 bg-zinc-600/50 rounded-md relative z-10`}>
          <span className={isEnabled ? "text-white font-medium" : "font-medium"}>
            {isEnabled ? "Music Haptics Enabled" : "Enable Music Haptics"}
          </span>
          <button
            onClick={() => {
              if (!isEnabled) {
                onEnable(); // Enable haptics when a preset is selected
              }
            }}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              isEnabled ? "bg-yellow-500" : "bg-zinc-800"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                isEnabled ? "translate-x-6" : "translate-x-1"
              }`}
            />
          </button>
        </div>
      </div>

      <div className="space-y-2 overflow-y-auto max-h-56 md:max-h-[35rem] px-2">
        {Object.entries(DEFAULT_PRESETS).map(([key, preset]) => (
          <button
            key={key}
            onClick={() => handleSelect(key)}
            className={`w-full px-4 py-2 text-left rounded-md transition flex items-center gap-3 ${
              currentPreset === key ? "bg-yellow-500 text-black" : "bg-zinc-700 hover:bg-zinc-600"
            }`}
          >
            <span className="text-xl">{preset.icon}</span>
            <div>
              <div>{key}</div>
              <span className="truncate block text-sm text-zinc-400">{preset.description}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
